/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Override cart error message for sold out products
  document.addEventListener('DOMContentLoaded', function() {
    // Override the addToCartError function if it exists
    if (window.theme && window.theme.CartDrawer && window.theme.CartDrawer.prototype) {
      const originalAddToCartError = window.theme.CartDrawer.prototype.addToCartError;
      if (originalAddToCartError) {
        window.theme.CartDrawer.prototype.addToCartError = function(data, button) {
          // Check if this is a sold out error and customize the message
          if (data && (data.message && data.message.includes('売り切れ') || data.description && data.description.includes('売り切れ'))) {
            data.message = 'Sorry, this item is SOLD OUT.';
            data.description = '';
          }
          // Call the original function with modified data
          return originalAddToCartError.call(this, data, button);
        };
      }
    }
  });

  // Alternative approach: Override error message display directly
  document.addEventListener('DOMContentLoaded', function() {
    // Override innerHTML for error containers
    const originalInnerHTML = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
    Object.defineProperty(Element.prototype, 'innerHTML', {
      set: function(value) {
        // Check if this is an error message container and contains sold out text
        if (this.classList && this.classList.contains('errors') && 
            (value.includes('売り切れ') || value.includes('は既に売り切れました'))) {
          value = '<div class="errors">Sorry, this item is SOLD OUT.<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>';
        }
        return originalInnerHTML.set.call(this, value);
      },
      get: originalInnerHTML.get
    });
  });

  // Third approach: Use MutationObserver to catch error messages
  document.addEventListener('DOMContentLoaded', function() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if this is an error message with sold out text
              if (node.classList && node.classList.contains('errors')) {
                const textContent = node.textContent || '';
                if (textContent.includes('売り切れ') || textContent.includes('は既に売り切れました')) {
                  node.innerHTML = 'Sorry, this item is SOLD OUT.<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>';
                }
              }
            }
          });
        }
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  // Fourth approach: Add CSS to hide Japanese error messages and show custom message
  document.addEventListener('DOMContentLoaded', function() {
    const style = document.createElement('style');
    style.textContent = `
      .errors:has-text("売り切れ") {
        display: none !important;
      }
      .errors:has-text("は既に売り切れました") {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

